import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import recommendedForYouQuery from './query'
import {
  IRecommendedForYouVariables,
  IRecommendedForYouResponse,
} from './types'

/**
 * Hook declaration to obtain a lazy query of personalised "recommended
 * for you" products. Ships dark in Phase 1 — wired in code but not yet
 * activated by SCS config.
 * @param options: LazyQueryHookOptions without the fetch-policy keys
 * @internal
 */
const useLazyRecommendedForYou = (
  options?: Omit<
    LazyQueryHookOptions<
      IRecommendedForYouResponse,
      IRecommendedForYouVariables
    >,
    'fetchPolicy' | 'nextFetchPolicy' | 'initialFetchPolicy'
  >,
) => {
  return useLazyQuery<
    IRecommendedForYouResponse,
    IRecommendedForYouVariables
  >(recommendedForYouQuery, {
    ...options,
    fetchPolicy: 'no-cache',
    // Neutralised beside the pin, not merely omitted from the type: both
    // survive the spread otherwise, and `nextFetchPolicy` would take over
    // from the second fetch onward.
    nextFetchPolicy: undefined,
    initialFetchPolicy: undefined,
  })
}

export { useLazyRecommendedForYou }
